import {
  Box,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';

import { CloseCircleOutline } from '@aslanpay/portal-common-lib';

import { CreateCompanyChoiceModalProps } from './types';

/** First step of creating a company: choose the manual "Create Company" flow (unchanged) or the ASD-4330
 * Connect-Cezanne discovery wizard - an additive alternative for onboarding a brand-new Cezanne customer with
 * no company yet. Card styling matches the existing selectable-card pattern from CompanyModulesForm's Module. */
function CreateCompanyChoiceModal({
  isOpen,
  onClose,
  onChooseManual,
  onChooseCezanne,
}: CreateCompanyChoiceModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent width={{ base: '100vw', sm: '600px' }}>
        <ModalHeader>
          <HStack>
            <Text as="h6">How do you want to create this company?</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody pb="30px">
          <Stack spacing="12px">
            <Box
              bg="brand.lightGray2"
              borderRadius={3}
              border="1px solid"
              borderColor="brand.lightGray1"
              p="20px"
              width="100%"
              cursor="pointer"
              _hover={{ backgroundColor: 'brand.lightPurple', borderColor: 'brand.purpleAlpha30' }}
              onClick={onChooseManual}
            >
              <VStack align="start" spacing={0}>
                <Text textStyle="h5SemiBold">Create manually</Text>
                <Text marginTop="3px !important" textStyle="extraSmallMedium">
                  Enter the company&apos;s details yourself.
                </Text>
              </VStack>
            </Box>
            <Box
              bg="brand.lightGray2"
              borderRadius={3}
              border="1px solid"
              borderColor="brand.lightGray1"
              p="20px"
              width="100%"
              cursor="pointer"
              _hover={{ backgroundColor: 'brand.lightPurple', borderColor: 'brand.purpleAlpha30' }}
              onClick={onChooseCezanne}
            >
              <VStack align="start" spacing={0}>
                <Text textStyle="h5SemiBold">Create via Cezanne</Text>
                <Text marginTop="3px !important" textStyle="extraSmallMedium">
                  Connect a Cezanne tenant and validate its data before the company is created.
                </Text>
              </VStack>
            </Box>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default CreateCompanyChoiceModal;
